import type { CampBulkCreatePayload } from '@court-sync/shared';
import { apiPost } from './apiClient';

export const campService = {
  async createBulk(payload: CampBulkCreatePayload): Promise<{ lessonIds: string[] }> {
    const response = await apiPost<{ lessonIds: string[] }>('/lessons/camps/bulk', payload);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to create camps');
  },
};
